module.exports = __webpack_public_path__ + "img/9788996100102.75bbc012.jpg";